import {defineStore} from 'pinia';
import BusinessModel from '@/model/menu/BusinessModel'

/**
 * Store reprezentuje kontext pre vytváranie ponuky denného menu
 */
export const useDailyMenuOfferStore = defineStore('DailyMenuOfferStore', {

  state: () => {
    return {
      selectedBusiness: null as BusinessModel | null,
    }
  },

  actions: {

  }
});
